import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { BookOpenIcon, HomeIcon, ShoppingBagIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import Header2 from './Header2';
import Sidebar2 from './Sidebar2';

const readCollapsed = () => {
  try { return localStorage.getItem('sidebar2_collapsed') === 'true'; } catch { return false; }
};

// The app shell: navbar on top, navy sidebar below it
// (icon rail when collapsed); drawer and bottom tabs on phones.
const Layout2 = () => {
  const { pathname } = useLocation();
  const [collapsed, setCollapsedState] = useState(readCollapsed);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const setCollapsed = (value) => {
    setCollapsedState(value);
    try { localStorage.setItem('sidebar2_collapsed', String(value)); } catch { /* per-device preference only */ }
  };

  useEffect(() => { setDrawerOpen(false); }, [pathname]);

  const toggleMenu = () => {
    if (window.matchMedia('(min-width: 768px)').matches) setCollapsed(!collapsed);
    else setDrawerOpen(!drawerOpen);
  };

  const tabs = [
    { label: 'Home', to: '/dashboard', icon: HomeIcon },
    { label: 'Courses', onClick: () => setDrawerOpen(true), icon: BookOpenIcon },
    { label: 'Store', to: '/store', icon: ShoppingBagIcon },
    { label: 'Profile', to: '/settings', icon: UserCircleIcon },
  ];

  // Taking a test or playing a game: navbar only, full width, no sidebar or tabs
  const focus = /^\/exam\/(?!create\/?$)[^/]+\/?$/.test(pathname) || /^\/games\/.+\/play\/?$/.test(pathname);
  if (focus) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
        <Header2 focus />
        <main className="pt-16"><Outlet /></main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <Header2 onMenu={toggleMenu} />
      <Sidebar2 collapsed={collapsed} setCollapsed={setCollapsed} open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      {drawerOpen && <div className="fixed inset-0 top-16 z-30 bg-slate-950/70 backdrop-blur-sm md:hidden" onClick={() => setDrawerOpen(false)} aria-hidden="true" />}

      <main className={`pt-16 transition-[padding] duration-300 ${collapsed ? 'md:pl-[72px]' : 'md:pl-64'}`}>
        <div className="p-3 pb-24 sm:p-6 md:pb-6">
          <Outlet />
        </div>
      </main>

      {/* Phone bottom tabs */}
      <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-slate-950/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden" aria-label="Main">
        <ul className="grid grid-cols-4">
          {tabs.map(({ label, to, onClick, icon: Icon }) => {
            const active = to ? pathname === to : drawerOpen;
            const cls = `flex h-16 w-full flex-col items-center justify-center gap-0.5 text-xs font-medium ${active ? 'text-primary-300' : 'text-gray-400 hover:text-white'}`;
            const body = (<><Icon className="h-6 w-6" aria-hidden="true" />{label}</>);
            return (
              <li key={label}>
                {to
                  ? <Link to={to} className={cls} aria-current={active ? 'page' : undefined}>{body}</Link>
                  : <button type="button" onClick={onClick} className={cls}>{body}</button>}
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Layout2;
